import type { FC } from 'react';

import type {
	EnquiriesSearchStoreState,
	EnquiriesSelectStoreState,
	EnquiriesStoreState,
} from 'Features/SellerCommunications/services';

import { ModalEnquiryListContainer } from './ModalEnquiryListContainer';
import { ModalEnquirySelectListItems } from './ModalEnquirySelectListItems';

interface ModalEnquiryListProps {
	enquiries: EnquiriesStoreState['enquiries'];
	filteredSaleIds?: EnquiriesSearchStoreState['filteredSaleIds'];
	interactedSaleIds: EnquiriesSelectStoreState['interactedSaleIds'];
	onToggle: (id: string) => void;
}

export const ModalEnquiryList: FC<ModalEnquiryListProps> = ({
	enquiries,
	filteredSaleIds,
	interactedSaleIds,
	onToggle,
}) => {
	return (
		<ModalEnquiryListContainer>
			<ModalEnquirySelectListItems
				enquiries={enquiries}
				filteredSaleIds={filteredSaleIds}
				interactedSaleIds={interactedSaleIds}
				onToggle={onToggle}
			/>
		</ModalEnquiryListContainer>
	);
};
